import { Sun, Moon, Monitor } from "lucide-react";
import useTheme from "../../hooks/useTheme";

// Cycles dark → light → system → dark…
// `compact` variant strips the label so it fits in tight nav strips.
export default function ThemeToggle({ compact = false, className = "" }) {
  const { pref, resolved, cycle } = useTheme();

  const Icon = pref === "system" ? Monitor : resolved === "light" ? Sun : Moon;
  const label =
    pref === "system" ? `System (${resolved})` :
    pref === "light"  ? "Light" :
    "Dark";

  const title = `Theme: ${label} — click to cycle`;

  if (compact) {
    return (
      <button
        type="button"
        onClick={cycle}
        title={title}
        aria-label={title}
        className={`inline-flex items-center justify-center w-8 h-8 rounded-md border border-border-default bg-bg-secondary text-text-primary hover:bg-bg-primary transition-colors ${className}`}
      >
        <Icon className="w-4 h-4" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={cycle}
      title={title}
      aria-label={title}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-border-default bg-bg-secondary text-text-primary text-xs uppercase tracking-wider hover:bg-bg-primary transition-colors ${className}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {label}
    </button>
  );
}
